import React from "react"

import { useState, useEffect, useCallback, useContext } from 'react'

import DodonesDayShow from 'app/dodones/day/Show'
import DodonesGenericShow from 'app/dodones/generic/Show'
import DodonesRecordableProgressionShow from 'app/dodones/recordable_progression/Show'

import DodoneContext from 'app/dodones/Context'
import HeaderContext from 'app/HeaderContext'
import DodoneMenu from 'app/dodones/Menu'

function resolveShowView(typeViewPrefix) {
  if(typeViewPrefix == 'Day')
    return DodonesDayShow;

  if(typeViewPrefix == 'Generic')
    return DodonesGenericShow;

  if(typeViewPrefix == 'Birl')
    return DodonesGenericShow;

  if(typeViewPrefix == 'RecordableProgression')
    return DodonesRecordableProgressionShow;
}

export default () => {
  const { setMenuContent } = useContext(HeaderContext);
  const { dodone } = useContext(DodoneContext);

  // useEffect(() => {
  //   console.log(setMenuContent)
  //   // setMenuContent(dodone ? DodoneMenu : null )
  //   console.log(DodoneMenu)

  //   // Cleanup function
  //   // return () => setMenuContent(null);
  // }, [dodone])

  const DodonesSelectedShow = resolveShowView(dodone.dodoable.typeViewPrefix)

  return <DodonesSelectedShow />;
}
